import { Howl, HowlOptions } from 'howler';
import buttonDownSoundSrc from '@/assets/sounds/button_down.wav';
import buttonPressSoundSrc from '@/assets/sounds/button_press.wav';
import lost1SoundSrc from '@/assets/sounds/lost1.wav';
import lost2SoundSrc from '@/assets/sounds/lost2.wav';
import lost3SoundSrc from '@/assets/sounds/lost3.wav';
import win1SoundSrc from '@/assets/sounds/win1.wav';
import win2SoundSrc from '@/assets/sounds/win2.wav';
import win3SoundSrc from '@/assets/sounds/win3.wav';

type SoundSource = string | string[];

/**
 * Returns a random Howl sound from an array.
 */
export function getRandomSound(sounds: Howl[]): Howl {
	return sounds[Math.floor(Math.random() * sounds.length)];
}

/**
 * Utility to create a Howl instance with default options.
 */
export function createSound(src: SoundSource, volume = 0.15, overrides: Partial<HowlOptions> = {}): Howl {
	return new Howl({
		src: Array.isArray(src) ? src : [src],
		volume,
		// Preload ensures the audio buffer is ready when we first try to play; some browsers
		// will silently fail if we attempt playback before the resource is fetched.
		preload: true,
		...overrides,
	});
}

/**
 * Create a group of Howl instances for the provided sources.
 */
export function createSoundGroup(sources: SoundSource[], volume = 0.15, overrides: Partial<HowlOptions> = {}): Howl[] {
	return sources.map((source) => createSound(source, volume, overrides));
}

const WIN_SOUND_SOURCES: SoundSource[] = [win1SoundSrc, win2SoundSrc, win3SoundSrc];

const LOSE_SOUND_SOURCES: SoundSource[] = [lost1SoundSrc, lost2SoundSrc, lost3SoundSrc];

export const sharedWinSounds = createSoundGroup(WIN_SOUND_SOURCES);
// Tiered win sound scale: map "small → huge" wins to progressively more exciting sounds.
// Duplicate sources for now; replace with additional recordings as they become available.
const WIN_SOUND_TIER_SOURCES: SoundSource[] = [
	win1SoundSrc,
	win1SoundSrc,
	win2SoundSrc,
	win2SoundSrc,
	win3SoundSrc,
	win3SoundSrc,
	win3SoundSrc,
];
export const sharedWinSoundsTiered = createSoundGroup(WIN_SOUND_TIER_SOURCES);
export const sharedLoseSounds = createSoundGroup(LOSE_SOUND_SOURCES);

export const buttonDownSound = createSound(buttonDownSoundSrc, 0.04);
export const buttonPressSound = createSound(buttonPressSoundSrc, 0.04);
